import { AppState } from 'common/store/reducer'

export const getApiUrl = (state: AppState): string => state.root.apiUrl
export const isAuthenticated = (state: AppState): boolean => {
  return state.root.user ? !!state.root.user.id : false
}
